import * as yup from 'yup';
import i18n from 'i18next';

export const ForgotPasswordSchema = yup.object({
  email: yup.string().required(i18n.t('required', { ns: 'common' })),
});
